// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/'
import ElementUI from 'element-ui'
import MintUI from "mint-ui"
import BaiduMap from 'vue-baidu-map'
import 'mint-ui/lib/style.css'
import 'element-ui/lib/theme-chalk/index.css'
import  VueQuillEditor from 'vue-quill-editor'
import VueCropper from 'vue-cropper'
// import zhangyuTinymce from '@/components/zhangyuTinymce.vue'


import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import permission from '@/directive/permission/index.js' // 权限判断指令

// 权限指令
Vue.use(permission)
//import lodash from 'vue-lodash'
//const options = {name: 'lodash'};
//Vue.use(lodash, options)

Vue.config.productionTip = false;

// Vue.use(zhangyuTinymce)
Vue.use(VueCropper)
Vue.use(ElementUI);
Vue.use(VueQuillEditor);
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'B2UcXTJqb072iLKGDLq2BW0SYBAWB6Ji'
});
Vue.use(MintUI);

import Bus from './common/js/bus'
Vue.use(Bus);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js